/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/anchor-is-valid */
import "react-virtualized/styles.css";

import { CheckOutlined, CloseOutlined, HomeOutlined } from "@ant-design/icons";
import {
  Button,
  Form,
  Input,
  InputNumber,
  message,
  // Select,
  Spin,
  Switch,
  Tag
} from "antd";
import dayjs from "dayjs";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

import {
  loadDirectoryProfile,
  loadTeamExperience,
  loadTeamSkills
} from "../../lib/queries";
import { getSupaClient } from "../../lib/supabase";
/* eslint-disable no-template-curly-in-string */

const { Option } = Select;

const { TextArea } = Input;
const layout = {
  labelCol: {
    span: 8
  },
  wrapperCol: {
    span: 16
  }
};

const validateMessages = {
  required: "${label} is required!",
  types: {
    url: "${label} is not a valid url!",
    number: "${label} is not a valid number!"
  }
};
/*
Component to allow admin to edit any profile
Props: profile -> profile of the member
updateProfile -> callback function to load when object is updated
*/
const AdminEditProfile = (props) => {
  const [userData, setUserData] = useState(props.profile);
  const [loading, setLoading] = useState(true);
  const [profileVisible, setProfileVisible] = useState(
    props.profile?.directory_visible
  );
  const [form] = Form.useForm();
  const [formLayout, setFormLayout] = useState("horizontal");
  const [directorySkills, setDirectorySkills] = useState([]);
  const [directoryExperience, setDirectoryExperience] = useState([]);
  const teamId = localStorage.getItem("team-id");
  const supabase = getSupaClient();
  const navigate = useNavigate();
  // const selectInputRef = useRef();

  useLayoutEffect(() => {
    // console.log("in aep useeffect", props.profile);
    form.resetFields();
    setUserData(props.profile);
    setProfileVisible(props.profile.directory_visible);
    loadTeamSkills().then(setDirectorySkills);
    loadTeamExperience().then(setDirectoryExperience).then(setLoading(false));
  }, [props.profile]);

  useEffect(() => {
    return () => {
      console.log("cleaned up");
      form.resetFields();
      // selectInputRef.current.select.clearValue();
    };
  }, []);

  async function profileUpdated() {
    const { data, error } = await supabase
      .from("directory_users")
      .update({
        directory_edited: new Date()
      })
      .match({
        slack_id: userData.slack_id
      });
    if (error) {
      console.log("error in profile update", error);
    }
    const updatedProfile = await loadDirectoryProfile(userData.slack_id);
    setUserData(updatedProfile);
  }

  // handler to remove or add skills
  async function skillsChanged(property, secondArg) {
    // console.log(props, secondArg);
    if (secondArg.option) {
      // console.log("added", secondArg);
      const { data, error } = await supabase
        .from("directory_skills_user")
        .insert({
          team: teamId,
          directory_user: userData.slack_id,
          skill: secondArg.option.id
        });
      if (error) {
        message.error("Error saving");
      }
      if (data) {
        // update the profile from the parent
        props.updateProfile();
      }
      // update profile edited field
      profileUpdated();
    } else if (secondArg.removedValue) {
      // console.log("removed", secondArg);
      const { data, error } = await supabase
        .from("directory_skills_user")
        .delete()
        .match({
          team: teamId,
          directory_user: userData.slack_id,
          skill: secondArg.removedValue.id
        });
      if (error) {
        message.error("Error saving");
      }
      if (data) {
        // update the profile from the parent
        props.updateProfile();
      }
    } else {
      message.info("Error");
    }
    profileUpdated();
  }

  // handler to remove or add experience
  async function experienceChanged(property, secondArg) {
    // console.log(props, secondArg);
    if (secondArg.option) {
      // console.log("added", secondArg);
      const { data, error } = await supabase
        .from("directory_industry_experience_user")
        .insert({
          team: teamId,
          directory_user: userData.slack_id,
          industry_experience: secondArg.option.id
        });
      if (error) {
        message.error("Error saving");
      }
      if (data) {
        // update the profile from the parent
        props.updateProfile();
      }
      profileUpdated();
    } else if (secondArg.removedValue) {
      // console.log("removed", secondArg);
      const { data, error } = await supabase
        .from("directory_industry_experience_user")
        .delete()
        .match({
          team: teamId,
          directory_user: userData.slack_id,
          industry_experience: secondArg.removedValue.id
        });
      if (error) {
        message.error("Error saving");
      }
      if (data) {
        // update the profile from the parent
        props.updateProfile();
      }
      // update profile edited field
      profileUpdated();
    } else {
      message.info("Error");
    }
  }

  const onFinish = async (formData) => {
    const { data, error } = await supabase
      .from("directory_users")
      .update(formData)
      .match({
        slack_id: userData.slack_id
      });
    if (error) {
      console.log("error in onSave", error);
      message.error("Error saving.");
    } else {
      console.log("data", data);
      const updatedProfile = await loadDirectoryProfile(userData.slack_id);
      console.log("updatedProfile", updatedProfile);
      setUserData(updatedProfile);
      message.success("Successfully updated profile!");
      window.analytics.track("Member profile updated");
    }
  };
  /**
   * Purpose:
   * Params
   */
  const changeProfileVisibility = async () => {
    const { data, error } = await supabase
      .from("directory_users")
      .update({
        directory_visible: !profileVisible,
        directory_edited: new Date()
      })
      .match({
        slack_id: userData.slack_id
      });
    if (error) {
      console.log("error in onSave", error);
      message.error("Error saving.");
    } else {
      const updatedProfile = await loadDirectoryProfile(userData.slack_id);
      setUserData(updatedProfile);
      setProfileVisible(!profileVisible);
      message.success("Successfully changed!");
    }
  };

  const formatDate = () => {
    if (userData.directory_edited) {
      return dayjs(userData.directory_edited).format("DD MMM,YYYY");
    }
    return "";
  };

  return (
    <div>
      <Spin spinning={loading}>
        <div className="bg-white rounded-lg shadow-sm border-gray-900 w-2/3 mx-auto">
          <div className="p-2 flex flex-row">
            <div className="pl-2 pt-2 w-1/2 text-left flex-grow">
              <div className="p-2">
                {userData?.name ? (
                  <Form
                    {...layout}
                    form={form}
                    name="nest-messages"
                    onFinish={onFinish}
                    initialValues={props.profile}
                    validateMessages={validateMessages}
                  >
                    <Form.Item name="directory_title" label="Title">
                      <Input />
                    </Form.Item>

                    <Form.Item name="directory_bio" label="Bio">
                      <Input.TextArea />
                    </Form.Item>
                    <Form.Item name="directory_location" label="Location">
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="directory_connecting"
                      label="Open to connecting"
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="directory_interest_free_text"
                      label="Interests"
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item name="directory_looking" label="Looking to meet">
                      <Input />
                    </Form.Item>
                    <Form.Item label="Skill" />

                    <Form.Item
                      name="directory_experience"
                      label="Experience"
                      rules={[
                        {
                          type: "number",
                          min: 0,
                          max: 99
                        }
                      ]}
                    >
                      <InputNumber placeholder="# of years" />
                    </Form.Item>
                    <Form.Item
                      type="url"
                      name="directory_linkedin"
                      label="Linkedin URL"
                      rules={[
                        {
                          type: "url"
                        }
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      type="url"
                      name="directory_twitter"
                      label="Twitter URL"
                      rules={[
                        {
                          type: "url"
                        }
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item name="directory_pronouns" label="Pronouns">
                      <Input placeholder="Preferred pronouns" />
                    </Form.Item>
                    <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
                      <Button type="primary" htmlType="submit">
                        Save
                      </Button>
                    </Form.Item>
                  </Form>
                ) : null}
              </div>

              {/* <TextArea
                rows={4}
                value={userData.directory_bio}
                onChange={onBioChange}
              />
              <Button type="primary" className="mt-10" onClick={onSave}>
                Save
              </Button>
               */}
            </div>

            <div className="flex w-1/2 flex-col float-right p-5">
              <div className="space-x-2 flex flex-row text-center">
                <p>Profile visible?</p>
                <Switch
                  className="w-1 mb-5 float-right"
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                  onChange={changeProfileVisibility}
                  checked={profileVisible}
                />
              </div>

              <div className="mt-4">Skills </div>
              <Select
                key="my_unique_select_key_skill"
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                options={directorySkills}
                value={props.profile.directory_skills}
                isMulti
                onChange={skillsChanged}
              />
              <div className="mt-4">Industry experience </div>
              <Select
                key="my_unique_select_key_industry"
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                value={props.profile.directory_industry_experience}
                options={directoryExperience}
                isMulti
                onChange={experienceChanged}
              />
              <p className="mt-4">Last updated: {formatDate()}</p>
              <p className="mt-4">
                Timezone:{" "}
                {props.profile.tz_label
                  ? props.profile.tz_label
                  : "No timezone"}
              </p>
            </div>
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default AdminEditProfile;
